// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"9bd1afc7","200":"4af54e56","246":"8da1c0d5","305":"d25f08c9","325":"c2e67291","457":"5cf6e00d","489":"f01fd938","510":"89bab0d6","525":"a73fbfd1","634":"1f05a8c3","637":"be727e05","870":"118b4bd3","984":"1467e627"}[chunkId] + ".chunk.js";
};